import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from "react";
import type { CognitoUserSession } from "amazon-cognito-identity-js";
import * as auth from "./authService";
type Value = { session: CognitoUserSession | null; loading: boolean; refresh: () => Promise<void>; signOut: () => void };
const Context = createContext<Value | null>(null);
export function AuthProvider({ children }: { children: ReactNode }) {
  const [session, setSession] = useState<CognitoUserSession | null>(null); const [loading, setLoading] = useState(true);
  const refresh = async () => { setSession(await auth.currentSession()); setLoading(false); }; useEffect(() => { void refresh(); }, []);
  const value = useMemo(() => ({ session, loading, refresh, signOut: () => { auth.signOut(); setSession(null); } }), [session, loading]);
  return <Context.Provider value={value}>{children}</Context.Provider>;
}
export const useAuth = () => { const value = useContext(Context); if (!value) throw new Error("useAuth must be used inside AuthProvider"); return value; };

export const hasCognitoGroup = (session: CognitoUserSession | null, groupName: string) => {
  const rawGroups = session?.getIdToken().decodePayload()?.["cognito:groups"];
  const groups = Array.isArray(rawGroups) ? rawGroups : String(rawGroups || "").split(",");
  return groups.map((group) => String(group).trim()).includes(groupName);
};
